import { ASSETS_URL } from '../commonUtils';

export const MAIL_ICON = `${ASSETS_URL}/mail.svg`;
export const UNLOCK_ICON = `${ASSETS_URL}/unlock.svg`;
export const GMAIL_ICON = `${ASSETS_URL}/gmail.svg`;
export const PEN_ICON = `${ASSETS_URL}/pen.svg`;
export const PEN_GREY_ICON = `${ASSETS_URL}/pen-grey.svg`;
export const EYE_ICON = `${ASSETS_URL}/eye.svg`;
export const LOGOUT_ICON = `${ASSETS_URL}/logout.svg`;
export const SEARCH_ICON = `${ASSETS_URL}/search.svg`;
export const TRASH_ICON = `${ASSETS_URL}/trash.svg`;
export const HAMB_MENU_ICON = `${ASSETS_URL}/hamb-menu.svg`;
export const HOME_ICON = `${ASSETS_URL}/home.svg`;
export const COMMENT_ICON = `${ASSETS_URL}/comment.svg`;
export const CROSS_ICON = `${ASSETS_URL}/cross.svg`;
// export const GMAIL_ICON = '';
